import { useId, useState } from "react";
import {
  formatLicensePlateOnBlur,
  getLicensePlateFormatHint,
  sanitizeLicensePlateInput,
} from "@/lib/licensePlate";

type Props = {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  className?: string;
  id?: string;
  disabled?: boolean;
};

export function LicensePlateInput({
  value,
  onChange,
  required,
  className = "eh-input uppercase",
  id: idProp,
  disabled,
}: Props) {
  const autoId = useId();
  const inputId = idProp ?? autoId;
  const hintId = `${inputId}-hint`;
  const [touched, setTouched] = useState(false);

  const hint = touched ? getLicensePlateFormatHint(value) : null;

  return (
    <>
      <input
        id={inputId}
        type="text"
        className={className}
        value={value}
        onChange={(e) => onChange(sanitizeLicensePlateInput(e.target.value))}
        onBlur={() => {
          setTouched(true);
          const formatted = formatLicensePlateOnBlur(value);
          if (formatted !== value) onChange(formatted);
        }}
        placeholder="z. B. AB-C 1234"
        autoComplete="off"
        autoCapitalize="characters"
        spellCheck={false}
        required={required}
        disabled={disabled}
        aria-invalid={hint ? true : undefined}
        aria-describedby={hint ? hintId : undefined}
      />
      <p className="mt-1 text-xs text-slate-500">
        Format AB-C 1234 – Leerzeichen und Bindestrich werden automatisch gesetzt.
      </p>
      {hint ? (
        <p
          id={hintId}
          className="mt-1.5 rounded-md border border-amber-200 bg-amber-50 px-2.5 py-1.5 text-xs leading-relaxed text-amber-950"
          role="status"
        >
          {hint}
        </p>
      ) : null}
    </>
  );
}
